import { getStore } from 'owa-mail-compose-store';

export default function isEncryptionTemplateAvailable(templateIds?: string[]): boolean {
    const composeStore = getStore();
    const { complianceConfigurations, messageClassifications } = composeStore;

    if (templateIds && templateIds.length > 0) {
        return templateIds.some(
            curValue =>
                complianceConfigurations.has(curValue) || messageClassifications.has(curValue)
        );
    }

    return (
        composeStore.complianceConfigurations.size > 0 ||
        composeStore.messageClassifications.size > 0
    );
}
